import React from 'react'
import Navbar from '../../Components/Navbar'
import SystemHeader from '../../Components/SystemHeader'
import SystemServices from '../../Components/SystemServices'
import Footer from '../../Components/Footer'

const System = () => {
  return (
    <div>
      <Navbar/>
      <SystemHeader/>
      <SystemServices/>
      <Footer/>
      
      
    </div>
  )
}

export default System
